import { useState } from "react";
import { useSelector } from "react-redux";
import { Plus } from "lucide-react";
import AddEditExperienceModal, {
  IExperience,
} from "./components/AddEditExperienceModal";
import ExperienceCard from "./components/ExperienceCard";
import { RootState } from "@store/reducers";

const Experience2 = () => {
  const experiences = useSelector(
    (state: RootState) => state.auth.user.experiences,
  );
  const [showAddEditModal, setshowAddEditModal] = useState(false);
  const [editingExperience, setEditingExperience] = useState<
    IExperience | undefined
  >(undefined);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <span className="font-semibold text-sm">Work Experience</span>
        <button
          onClick={() => {
            setEditingExperience(undefined);
            setshowAddEditModal(true);
          }}
          className="flex items-center gap-1 bg-primary font-semibold text-xs text-white rounded-md py-1.5 px-3 hover:bg-primary/95"
        >
          <Plus fill={"white"} size={15} />
          Add experience
        </button>
      </div>
      {experiences?.map((experience) => {
        return (
          <ExperienceCard
            key={experience?._id ?? experience?.jobTitle}
            experience={experience}
            setShowAddEditExperience={(data: IExperience) => {
              setEditingExperience(data);
              setshowAddEditModal(true);
            }}
          />
        );
      })}
      <AddEditExperienceModal
        showModal={showAddEditModal}
        setShowModal={(open) => {
          setshowAddEditModal(open as boolean);
          if (!open) setEditingExperience(undefined);
        }}
        experience={editingExperience}
      />
    </div>
  );

  // return (
  //   <div ref={ref} className="flex flex-col flex-1 px-6">
  //     {isNullOrEmpty(experiences) ? (
  //       <div className="flex flex-1  flex-col items-center justify-center mt-16">
  //         <p className="text-charcoal font-semibold">
  //           No Work Experience Created
  //         </p>
  //         {!showProfile && (
  //           <>
  //             <p className="mt-2 mb-5">Create a Work Experience Now!</p>
  //             <button
  //               onClick={() => {
  //                 setShowModal(true);
  //                 setIsAddingNew(true);
  //               }}
  //               className="flex items-center justify-center border bg-green-600 rounded-md px-2 py-1 gap-1 text-white font-medium text-sm"
  //             >
  //               <PlusIcon className={"w-4 h-4"} fill={"white"} />
  //               Add Experience
  //             </button>
  //           </>
  //         )}
  //       </div>
  //     ) : (
  //       experiencesDummyData?.map((experience) => {
  //         return (
  //           <ExperienceCard
  //             key={experience?.jobTitle}
  //             experience={experience}
  //           />
  //         );
  //       })
  //       // <ExperienceBlock experiences={experiences} showOnly />
  //     )}

  //     {showModal && (
  //       <div
  //         className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50"
  //         onClick={closeModal}
  //       >
  //         <div
  //           className="flex overflow-hidden flex-col bg-white rounded-lg relative w-[60%] max-h-[80%] ml-9 max-2xl:w-[70%] max-xl:w-[87%] max-xl:ml-16"
  //           onClick={(e) => e.stopPropagation()}
  //         >
  //           <ExperienceBlock
  //             popUpShow
  //             experiences={experiences}
  //             closeModal={closeModal}
  //             setExperiences={setExperiences}
  //             isAddingNew={isAddingNew}
  //           />
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );
};

export default Experience2;
